import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { fetchForms, fetchBridgedResource } from '@kineticdata/react';
import { actions, types } from '../modules/settingsApp';
import {
  C,
  selectServicesKapp,
  selectSurveyKapp,
} from '@kineticdata/bundle-common';

// Fetch all agreements, and all datastore forms
export function* fetchAppDataSaga() {
  const servicesKapp = yield select(selectServicesKapp);
  const surveyKapp = yield select(selectSurveyKapp);

  const [agreementResults, formResults, adminFormsResults] = yield all([
    call(fetchBridgedResource, {
      kappSlug: servicesKapp && servicesKapp.slug,
      formSlug: C.FORM_SLUG_SHARED_RESOURCES,
      bridgedResourceName: 'Agreements',
    }),
    call(fetchForms, {
      kappSlug: 'datastore',
      limit: 1000,
      include: 'authorization',
    }),
    call(fetchForms, {
      kappSlug: 'admin',
      limit: 1,
    }),
  ]);

  let formList = formResults.forms || [];
  let formPageToken = formResults.nextPageToken;
  let formError = formResults.error;

  while (!!formPageToken) {
    const { forms, error, nextPageToken } = yield call(fetchForms, {
      kappSlug: 'datastore',
      limit: 1000,
      include: 'authorization',
      pageToken: formPageToken,
    });

    if (error) {
      formError = error;
    } else if (Array.isArray(forms)) {
      formList = formList.concat(forms);
    }
    formPageToken = nextPageToken;
  }

  const me = yield select(state => state.app.profile);

  yield put(
    actions.fetchAppDataComplate({
      agreements: agreementResults.records,
      forms: formList,
      adminFormsAccess:
        adminFormsResults.forms && adminFormsResults.forms.length > 0,
      me,
      servicesKapp,
      surveyKapp,
      errors: [agreementResults.error, formError].filter(Boolean),
    }),
  );
}

export function* watchSettingsApp() {
  yield takeEvery(types.FETCH_APP_DATA_REQUEST, fetchAppDataSaga);
}
